import { useStaticQuery, graphql } from 'gatsby'
import Img from 'gatsby-image/withIEPolyfill'
import React from 'react'

const TechTeam = (props) => {
  const data = useStaticQuery(graphql`
    query {
      techTeam: file(
        relativePath: {
          eq: "components/pages/HiringPage/Sections/GallerySection/images/tech-team.jpg"
        }
      ) {
        childImageSharp {
          fluid(maxWidth: 834, maxHeight: 538, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp_noBase64
          }
        }
      }
    }
  `)

  return <Img fluid={data.techTeam.childImageSharp.fluid} {...props} />
}

export default TechTeam
